'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwDialog = require('../cwdialog/CwDialog');

var _CwDialog2 = _interopRequireDefault(_CwDialog);

var _CwFlyout = require('./CwFlyout.scss');

var _CwFlyout2 = _interopRequireDefault(_CwFlyout);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwFlyoutPointerPosition = {
  TOP_LEFT: 'TOP_LEFT',
  TOP_RIGHT: 'TOP_RIGHT',
  BOTTOM_LEFT: 'BOTTOM_LEFT',
  BOTTOM_RIGHT: 'BOTTOM_RIGHT'
};

var CwFlyout = function (_React$Component) {
  (0, _inherits3.default)(CwFlyout, _React$Component);

  function CwFlyout(props) {
    (0, _classCallCheck3.default)(this, CwFlyout);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CwFlyout.__proto__ || (0, _getPrototypeOf2.default)(CwFlyout)).call(this, props));

    _this.getFlyoutPointerPosition = function () {
      var windowHeight = window.innerHeight / 2;
      var windowWidth = window.innerWidth / 2;

      if (_this.props.xCoord <= windowWidth && _this.props.yCoord <= windowHeight) {
        return CwFlyoutPointerPosition.TOP_LEFT;
      }

      if (_this.props.xCoord <= windowWidth && _this.props.yCoord > windowHeight) {
        return CwFlyoutPointerPosition.BOTTOM_LEFT;
      }

      if (_this.props.xCoord > windowWidth && _this.props.yCoord <= windowHeight) {
        return CwFlyoutPointerPosition.TOP_RIGHT;
      }

      /* istanbul ignore else */
      if (_this.props.xCoord > windowWidth && _this.props.yCoord > windowHeight) {
        return CwFlyoutPointerPosition.BOTTOM_RIGHT;
      }
    };

    _this.getFlyoutPosition = function () {
      /* istanbul ignore if */
      if (!_this.flyout.dialog) {
        return {};
      }

      var left = _this.props.x;
      var top = _this.props.y;

      switch (_this._flyoutPointerPosition) {
        case CwFlyoutPointerPosition.TOP_LEFT:
          left -= 24;
          top += 8;
          break;
        case CwFlyoutPointerPosition.TOP_RIGHT:
          left += -_this.flyout.dialog.offsetWidth + 24;
          top += 8;
          break;
        case CwFlyoutPointerPosition.BOTTOM_LEFT:
          left -= 24;
          top += -_this.flyout.dialog.offsetHeight - 48;
          break;
        case CwFlyoutPointerPosition.BOTTOM_RIGHT:
          left += -_this.flyout.dialog.offsetWidth + 24;
          top += -_this.flyout.dialog.offsetHeight - 48;
          break;
        /* istanbul ignore next */
        default:
          break;
      }

      return { top: top, left: left };
    };

    _this._flyoutPointerPosition = undefined;

    _this.state = {
      style: undefined
    };
    return _this;
  }

  (0, _createClass3.default)(CwFlyout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._flyoutPointerPosition = this.getFlyoutPointerPosition();

      var style = (0, _assign2.default)({
        left: this.props.x,
        top: this.props.y
      }, this.getFlyoutPosition(), this.props.style);

      this.setState({ style: style });
    }
  }, {
    key: 'render',
    value: function render() {
      var _cx,
          _this2 = this;

      var dialogClass = (0, _classnames2.default)(this.props.className, _CwFlyout2.default.flyout, (_cx = {}, (0, _defineProperty3.default)(_cx, _CwFlyout2.default.flyoutTopLeft, this._flyoutPointerPosition === CwFlyoutPointerPosition.TOP_LEFT), (0, _defineProperty3.default)(_cx, _CwFlyout2.default.flyoutTopRight, this._flyoutPointerPosition === CwFlyoutPointerPosition.TOP_RIGHT), (0, _defineProperty3.default)(_cx, _CwFlyout2.default.flyoutBottomLeft, this._flyoutPointerPosition === CwFlyoutPointerPosition.BOTTOM_LEFT), (0, _defineProperty3.default)(_cx, _CwFlyout2.default.flyoutBottomRight, this._flyoutPointerPosition === CwFlyoutPointerPosition.BOTTOM_RIGHT), _cx));

      return _react2.default.createElement(_CwDialog2.default, (0, _assign2.default)({}, this.props, {
        'data-cwid': this.props.cwId,
        ref: function ref(flyout) {
          return _this2.flyout = flyout;
        },
        className: dialogClass,
        style: this.state.style
      }));
    }
  }]);
  return CwFlyout;
}(_react2.default.Component);

;

CwFlyout.propTypes = (0, _assign2.default)({
  /**
   * Specifies the x coordinate of the dialog box
   */
  x: _propTypes2.default.number,
  /**
   * Specifies the y coordinate of the dialog box
   */
  y: _propTypes2.default.number,
  xCoord: _propTypes2.default.number,
  yCoord: _propTypes2.default.number
}, _CwDialog2.default.propTypes);

exports.default = CwFlyout;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwflyout/CwFlyout.js
// module id = 370
// module chunks = 10